import BaseRequest from './BaseRequest';
import { API_URL } from '../config/config';

const CatalogoRequest = () => {
    return {
        buscarSecoes(guia, catalogType = "C"){
            return BaseRequest.axiosInst.get(
                `${API_URL}/catalogo/secoes`,
                {
                    headers: BaseRequest.publicHeaders(),
                    params: {guia, catalogType}
                },
            );
        },
        buscarDestaques({page = 1, perPage = 20, orderBy = 'obra'}, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/catalogo/destaques`,
                { headers: BaseRequest.publicHeaders(), cancelToken,  params: {page, perPage, orderBy} },
            );
        },
        buscarNoticias(guia, cancelToken = null) {
            return BaseRequest.axiosInst.get(
                `${API_URL}/catalogo/noticias`,
                { headers: BaseRequest.publicHeaders(), cancelToken,  params: {guia} },
            );
        },
    };
};

export default CatalogoRequest();
